import queryString from 'query-string';
import { config } from 'config';
import { restClient } from 'modules/shared/services/API/backend';
import { PaginatedListWithFilters, KeyValueFilter } from 'modules/shared/models';
import { Product, LightProduct, GetProduct, SearchProducts } from '../../models';

function readFilters(filters?: KeyValueFilter[] | null): string {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let queryParams: any;

    if (filters && filters.length > 0) {
        queryParams = {};
        for (let i = 0; i < filters.length; i += 1) {
            const currentFilter = filters[i];
            if (currentFilter.id !== 'sort') {
                if (currentFilter.values && currentFilter.values.length > 0) {
                    queryParams[currentFilter.id] = currentFilter.values.join('|');
                }
            }
        }
    }

    return queryParams ? queryString.stringify(queryParams) : '';
}

export const productService = {
    get: async ({ id, offline }: GetProduct) => {
        if (offline) {
            const response = await restClient.get<Product>(`${config.backend.rest.catalogueUrl}/product/${id}/offline`);
            return response.data;
        }
        const response = await restClient.get<Product>(`${config.backend.rest.catalogueUrl}/product/${id}`);
        return response.data;
    },
    searchByCategory: async ({ id, filters }: SearchProducts) => {
        const response = await restClient.get<PaginatedListWithFilters<LightProduct>>(
            `${config.backend.rest.catalogueUrl}/category/${id}/products?${readFilters(filters)}`,
        );
        return response.data;
    },
    searchByBrand: async ({ id, filters }: SearchProducts) => {
        const response = await restClient.get<PaginatedListWithFilters<LightProduct>>(
            `${config.backend.rest.catalogueUrl}/brand/${id}/products?${readFilters(filters)}`,
        );
        return response.data;
    },
    searchByName: async ({ id, filters }: SearchProducts) => {
        const response = await restClient.get<PaginatedListWithFilters<LightProduct>>(
            `${config.backend.rest.catalogueUrl}/product/products/${id}?${readFilters(filters)}`,
        );
        return response.data;
    },
};
